import * as React from 'react'
import {Util} from 'yougile-util'
import {Sync} from '@client/sync'
import {Tracking} from '@common/tracking'
import {TrackingEvent} from '@common/tracking-events'
import {crmStore} from '@components/crm/crm-store'
import {useLoadedLazyTaskEffect} from '@containers/hooks'
import {SearchResultItemType} from '@extensions/search'
import {ChatInfo, LocationType} from '../chat-info/chat-info'
import {TaskChatItemProps} from './types'

export const TaskChatListItem = ({
  withMe,
  ...props
}: TaskChatItemProps & {
  locationType: LocationType
  highlightType?: SearchResultItemType
  startFrom?: number
  endAt?: number
}) => {
  const bem = Util.bemFrom('task-chat-list', 'item')
  const onClick = () => {
    void Tracking.send(TrackingEvent.chatPanelClickTask)
  }
  const box = Sync.getCurrentSandbox()
  const task = box.getHub(props.chatId)
  const isDeal = crmStore.isDeal(task)
  const isCrmDefaultFieldsHub = crmStore.getCrmRoleOfHub(task)

  useLoadedLazyTaskEffect(task, 'task-chat-list-item')
  return (
    <div className={bem({withMe})} onClick={onClick}>
      <div className={bem('icon')} />
      <ChatInfo
        {...props}
        withMe={withMe}
        type={'task'}
        isLazy={task?.isLazy}
        isDeal={isDeal}
        isCrmDefaultFieldsHub={isCrmDefaultFieldsHub}
      />
    </div>
  )
}
